import Markdown from "react-markdown";
import { ENV } from "../../../Utils";

export const GptMessage = ({ text, imageAvatar }) => {
  const imageUrl = imageAvatar
    ? `${imageAvatar}`
    : `${ENV.BASE_PATH}/default-avatar.png`;

  //console.log("GptMessage -> imageUrl", `${ENV.BASE_PATH}/${imageAvatar}`);
  return (
    <div className="col-start-1 col-end-9 p-3 rounded-lg">
      <div className="flex flex-row items-start">
        <div className="flex items-center justify-center h-10 w-10 rounded-full bg-white  flex-shrink-0">
          <img src={imageUrl} alt="Avatar" className="h-10 w-10 rounded-full" />
        </div>
        <div className="relative ml-3 text-sm bg-black bg-opacity-25 pt-3 pb-2 px-4 shadow rounded-xl text-white">
          <Markdown>{text}</Markdown>
        </div>
      </div>
    </div>
  );
};
